// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2VW6V","additionalInfo":"AgreementModal_additionalInfo__3A2MP"};